import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getProductGroups = createAsyncThunk(
  "productGroup/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        ),
      );
      const params = new URLSearchParams();

      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${API_URL.ITEM_GROUP.SLUG}?${queryString}`,
      );
      // const product_list = data.data.list;
      // return { product_list };
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getProductGroupOverview = createAsyncThunk(
  "productGroupOverview/get",
  async (Id, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL.ITEM_GROUP.SLUG}/${Id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createProductGroup = createAsyncThunk(
  "productGroup/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${API_URL.ITEM_GROUP.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const createProductToGroup = createAsyncThunk(
  "productToGroup/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.ITEM_GROUP.ADD_NEW_ITEM_TO_GROUP}`,
        payload,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const editProductGroup = createAsyncThunk(
  "productGroup/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${API_URL.ITEM_GROUP.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const deleteProductGroup = createAsyncThunk(
  "productGroup/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${API_URL.ITEM_GROUP.SLUG}/${id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const updateStatusProductGroup = createAsyncThunk(
  "UpdateProductGroupStatus/put",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.ITEM_GROUP.SLUG}/UpdateStatus/${id}`,
      );
      dispatch(getProductGroupOverview(id));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const getProductGroupAttributes = createAsyncThunk(
  "ProductAttributes/get",
  async (groupId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.ITEM_GROUP.GET_ATTRIBUTES}/${groupId}`,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const productGroupSlice = createSlice({
  name: "productGroup",
  initialState: {
    product_group_list: [],
    current_values: null,
    active_payload: null,
    total_records: 0,
    product_group_overview: null,
    single_product_data: { modalOpen: false, id: null },
    product_group_attributes: {},
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
      state.product_group_list = [];
    },
    setSingleProductData(state, action) {
      state.single_product_data = action.payload;
    },
    resetProductGroupDetail(state) {
      state.product_group_overview = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductGroups.fulfilled, (state, action) => {
        state.product_group_list = action.payload.data.list;
        state.total_records = action.payload.data.totalRecords || 0;
      })
      .addCase(getProductGroupOverview.fulfilled, (state, action) => {
        state.product_group_overview = action.payload;
      })
      .addCase(getProductGroupAttributes.fulfilled, (state, action) => {
        state.product_group_attributes = action.payload;
      });
  },
});

export const {
  setCurrentValues,
  setActivePayload,
  resetCurrentValue,
  setSingleProductData,
  resetProductGroupDetail,
} = productGroupSlice.actions;
export default productGroupSlice.reducer;
